let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("IfGUb")).then(() => parcelRequire('fkfWe'));